export default __webpack_public_path__ + "assets/favicon16.png";